module.exports = {
	"title": "App",
	"reportList.table.heading.title": "Titel",
	"reportList.table.heading.reportType": "Befundtyp",
	"reportList.table.heading.version": "Version",
	"reportList.table.heading.createdAt": "Erstellt am",
	"reportList.table.heading.updatedAt": "Letzte Änderung",
	"reportList.table.heading.sharedWith": "Teilen",
	"reportList.table.heading.transferReport": "Weitergeben",
	"reportList.open.title.user": "In Bearbeitung",
	"reportList.approved.title.user": "Freigegeben",
	"reportList.closed.title.user": "Abgeschlossen",
	"reportList.open.title.manager": "In Bearbeitung",
	"reportList.approved.title.manager": "Freigegeben",
	"reportList.closed.title.manager": "Zur Freigabe",
	"reportList.savePdf.title": "PDF sichern",
	"reportList.copy.title": "Kopieren",
	"reportList.delete.title": "Löschen",
	"reportList.table.heading.examiner": "Prüfer",
	"reportList.table.heading.client": "Kunde",
	"reportList.report.name": "Befundname",
	"reportList.report.name.validationError": "Bitte geben Sie einen Befundnamen ein",
	"reportList.copy.modal.title": "Befund kopieren",
	"reportList.copy.modal.body.title": "Kopie von",
	"reportList.share.modal.title": "Befund teilen",
	"reportList.delete.modal.title": "Befund löschen",
	"reportList.delete.modal.body": "Der Befund sowie dessen Inhalt wird unwiederbringlich gelöscht. Möchten Sie ihn wirklich löschen?",
	"reportList.new.modal.title": "Neuen Befund erstellen",
	"reportList.client.noclient": "Kein Kunde",
	"reportList.client.modal.title": "Kundeninfo verwalten",
	"reportList.client.modal.createClient.name": "Name des Kunden",
	"reportList.client.modal.createClient.name.validationError": "Bitte geben Sie einen Namen für den Neuen Kunden",
	"reportList.client.modal.createClient.description": "Bitte geben Sie einen Namen für den Neuen Kunden",
	"reportList.client.modal.createClient.button": "Kunden generieren",
	"reportList.client.modal.mergeClients.button": "Kunden mergen",
	"reportList.clients.edit.title": "Kunden verwalten",
	"reportList.client.new": "Neuen Kunden generieren",
	"reportList.client.createFailed": "Kunde konnte nicht angelegt werden, möglicherweise existiert schon ein Kunde mit diesem Namen.",
	"reportList.client.createSucceeded": "Kunde wurde erfolgreich angelegt.",
	"reportList.clientModal.new.popoverText": "Einen neuen Kunden generieren.\nDer Name muss einzigartig innerhalb einer Firma sein.\nDer neue Kunde bekommt keine Befunde - \nUm bestehende Befunde eines anderen Kunden zuzuteilen, benutzen Sie bitte den unteren Teil.",
	"reportList.clientModal.merge.popoverText": "Kunden löschen und alle Befunde zu einem anderen Kunden übertragen.",
	"reportList.clientModal.merge.fromCustomer": "Von Kunde",
	"reportList.clientModal.merge.toCustomer": "Zu Kunde",
	"reportList.clientModal.merge.buttonText": "Kunden löschen und Befunde übertragen",
	"reportList.clientModal.merge.mergeSucceeded": "Alle Befunde übertragen, Kunde gelöscht.",
	"reportList.clientModal.merge.mergeFailed": "Übertragung konnte nicht durchgeführt werden.",
	"reportList.clientModal.newClient.helpText": "Es gibt keine Beschränkungen bei Namenseingabe",
	"reportList.clientModal.createClient": "Kunden anlegen",
	"reportList.new.modal.reportType.title": "Befundtyp",
	"reportList.new.modal.reportType.title.validationError": "Bitte wählen Sie einen Befundtypen aus",
	"reportList.show.title": "Ansehen",
	"reportList.shareModal.addUser": "hinzufügen",
	"reportList.shareModal.removeUser": "löschen",
	"report.detail.sidebar.report.title": "Befunde",
	"report.detail.editTitle.modal.title": "Umbenennen",
	"report.detail.editTitle.modal.subTitle": "Geben Sie einen eindeutigen Namen für den Befund ein.",
	"report.detail.sidebar.steps.title": "Schritte",
	"reportList.save.title": "Speichern",
	"reportList.edit.title": "Bearbeiten",
	"reportDetail.table.referenceMax": "Höchster Wert:",
	"reportDetail.table.referenceMin": "Niedrigster Wert:",
	"reportDetail.type.empty.postfix": "hinzufügen",
	"reportDetail.type.empty.postfix.first.uppercase": "Hinzufügen",
	"reportDetail.type.empty.postfix.edit": "bearbeiten",
	"reportDetail.type.empty.postfix.first.uppercase.edit": "Bearbeiten",
	"reportDetail.type.new.modal.title.postfix": "name",
	"reportDetail.type.new.modal.title.validationError": "Bitte geben Sie einen Namen ein",
	"reportDetail.type.new.modal.title.new.postfix": "Neu",
	"reportDetail.type.new.modal.predefinitions.category.title": "Kategorie auswählen",
	"reportDetail.type.new.modal.predefinitions.category.item.title": "Auswählen",
	"reportDetail.type.new.modal.description.title": "Beschreibung",
	"reportDetail.type.new.modal.predefinitions.category.validationError": "Bitte wählen Sie eine Kategorie aus",
	"reportDetail.type.new.modal.predefinitions.category.item.validationError": "Bitte wählen Sie einen Titel aus",
	"reportDetail.type.new.modal.predefinitions.list.empty": "Keine weiteren vordefinierten {namePlural} verfügbar",
	"reportDetail.type.new.modal.predefinitions.list.nomatch": "Keine vordefinierten {namePlural} gefunden, neu erstellen",
	"reportDetail.typeReferences.title": "Globale Referenz",
	"reportList.type.delete.modal.title.postfix": "löschen",
	"reportList.type.delete.modal.body": "Das Löschen kann nicht rückgängig gemacht werden. Alle Verknüpfungen werden aufgehoben.",
	"reportDetail.sidebar.saveReport": "Speichern",
	"reportDetail.sidebar.approve.button.title": "Befund freigeben",
	"reportDetail.sidebar.close.button.title": "Befund abschließen",
	"reportDetail.sidebar.reopen.button.title": "Befund für Prüfer wieder öffnen",
	"reportDetail.fields.title": "Parameter",
	"reportDetail.type.empty.crossReferences": "Keine {namePlural} vorhanden",
	"reportDetail.type.empty.parameters": "Keine Parameter vorhanden",
	"reportDetail.images.title": "Anhänge",
	"reportStep.table.addItem": "Tabelleneintrag hinzufügen",
	"reportStep.table.removeItem": "Zeile entfernen",
	"reportStep.table.showTable": "Eintrag anzeigen",
	"reportStep.table.hideTable": "Eintrag verbergen",
	"reportStep.type.closingUser": "Abschließen",
	"reportStep.type.closingManager": "Freigeben",
	"reportStep.table.modal.chooseType": "auswählen",
	"reportStep.table.modal.addType": "hinzufügen",
	"reportStep.choices.modal.addFreeText.title": "Freitext",
	"reportStep.choices.modal.addFreeText.label": "Freitext hinzufügen",
	"reportStep.choices.modal.showModal": "Option hinzufügen",
	"reportList.new.modal.description": "Geben Sie einen eindeutigen Namen für den Befund ein.",
	"reportDetail.report.state": "Status:",
	"reportStep.type.closingManager.contingent": "Verfügbares Kontingent:",
	"appDataField.title.optional": "(Optional)",
	"reportDetail.confirmDismissReportChanges": "Die aktuellen Änderungen wurden noch nicht gespeichert!\n\nWirklich verwerfen?"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/i18n/de.json
 ** module id = 901
 ** module chunks = 0
 **/